export default __webpack_public_path__ + "static/media/grad.1c43b09c.jpg";